import { formatMessage } from '@formatjs/intl';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { resetImage } from '../actions/createContentAction';
import { displayNotification } from '../actions/notificationActions';
import { updateMessageContent } from '../actions/nudgeActions';
import { MessageType } from '../constants/createSegment';
import { IMAGE_UPLOAD_ERROR, IMAGE_UPLOAD_SUCCESS } from '../constants/messages';
import { ResponseStatus } from '../enums/responseStatus';
import { templateContentSelector } from '../selectors/selectors';
import store from '../store';
import { addImageSection } from './templateBuilderUtil';

export const processImageFile = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.replace('data:', '').replace(/^.+,/, '');
      resolve(base64String);
    };
    reader.onerror = () => reject('error');
  });
};

export const addImageElement = content => {
  const elements = store.getState()?.createContent?.contentElements;
  const updatedContentElements = isEmpty(elements) ? [] : [...elements];
  updatedContentElements.push(content);
  store.dispatch(updateMessageContent(updatedContentElements));
  store.dispatch(resetImage());
};

export const updateImageUploadStatus = (imageDetails, setLoadingStatus) => {
  if (imageDetails?.status === ResponseStatus.SUCCESS) {
    if (imageDetails?.response?.imageUrl !== '') {
      const imageElement = addImageSection({
        source: imageDetails.response.imageUrl,
      });
      addImageElement(imageElement);
      setLoadingStatus(false);
      store.dispatch(
        displayNotification({
          type: MessageType.SUCCESS,
          message: IMAGE_UPLOAD_SUCCESS,
          timeout: 10000,
        }),
      );
    }
  } else if (imageDetails?.status === ResponseStatus.ERROR) {
    setLoadingStatus(false);
    store.dispatch(
      displayNotification({
        type: MessageType.SUCCESS,
        message: IMAGE_UPLOAD_ERROR,
        timeout: 10000,
      }),
    );
  }
};
